export default __webpack_public_path__ + "static/media/brij-colored.cb940c89.svg";